import React from 'react';
import { Image, Modal } from '@mantine/core';
import styles from './styles.scoped.css';
import IconWarning from '../../icons/IconWarning';
import Button from '../../elements/Button/Button';
import PropTypes from 'prop-types';

export default function ModalError({
  open,
  setModalError
}){
  return(
    <Modal centered opened={open} size={'lg'} withCloseButton={false}>
      <div className={styles.containerModal} >
        <Image src={'/assets/illu-error.svg'} width={200}/>
        <div style={{ marginLeft: 10 }}>
          <span className={styles.descModal}>Periode Data Melebihi 31 Hari</span>
          <hr className={styles.line}/>
          <div className={styles.warning}>
            <IconWarning />
            <span style={{ marginLeft: 10 }}>
                Maksimal 31 hari periode data yang dapat diunduh.
            </span>
          </div>
          <Button
            className={styles.btnClose}
            onClick={() => setModalError(false)}
          >Tutup</Button>
        </div>
      </div>
    </Modal>
  );
}

ModalError.propTypes = {
  open: PropTypes.bool,
  setModalError: PropTypes.func,
};

